/**
 * @generated SignedSource<<519208de0fc4f1079e05ebc0ac5c9aa8>>
 * @relayHash 9a1f2614b3c0ee211a903359c4922254
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 62e16717245dfcae33176feaf001c96a05188712c04853283d6693939660b8c1

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JourneyConfigurationPageQuery } from './JourneyConfigurationPageQuery.graphql';

import isValidationFGEnabled_provider from '@atlassian/jira-relay-provider/src/jira-journey-builder-improve-validation.relayprovider';
import isConditionsFGEnabled_provider from '@atlassian/jira-relay-provider/src/jsm-journey-builder-condition-smart-value.relayprovider';

const node: PreloadableConcreteRequest<JourneyConfigurationPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "62e16717245dfcae33176feaf001c96a05188712c04853283d6693939660b8c1",
    "metadata": {},
    "name": "JourneyConfigurationPageQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjirajourneybuilderimprovevalidationrelayprovider": isValidationFGEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmjourneybuilderconditionsmartvaluerelayprovider": isConditionsFGEnabled_provider
    }
  }
};

export default node;
